/* eslint-disable react/no-unstable-nested-components */
import { useQuery } from "@apollo/client";
import AmericanTotalCompensations from "components/company/v2/AmericanTotalCompensations";
import useAmericanIssuer from "components/company/v3/context/hooks/useAmericanIssuer";
import UnlockPremiumContentCTA from "components/conversion/UnlockPremiumContentCTA";
import SadFaceIcon from "components/icons/SadFaceIcon";
import LoadingSkeleton from "components/pages/TemplatesGalleryPage/LoadingSkeleton";
import useSelfie from "lib/hooks/useSelfie";
import TotalYearlyAmericanIssuerCompensation from "lib/queries/TotalYearlyAmericanIssuerCompensation";
import type {
  ITotalYearlyAmericanIssuerCompensationQuery,
  ITotalYearlyAmericanIssuerCompensationQueryVariables,
} from "lib/queries/__generated__/TotalYearlyAmericanIssuerCompensation.generated";
import { FormattedMessage } from "react-intl";

interface AmericanCompensationContentProps {
  tickerSymbol: string;
  isRenderPageDefault: boolean;
}

export default function AmericanCompensationContent({
  tickerSymbol,
  isRenderPageDefault,
}: AmericanCompensationContentProps) {
  const issuer = useAmericanIssuer();
  const viewer = useSelfie();

  const viewerIsPremiumSubscriber = !!viewer && viewer.isPremium && !viewer.isTrialing;

  const { data, loading } = useQuery<
    ITotalYearlyAmericanIssuerCompensationQuery,
    ITotalYearlyAmericanIssuerCompensationQueryVariables
  >(TotalYearlyAmericanIssuerCompensation, {
    variables: {
      tickerSymbol,
    },
  });

  if (loading) {
    return <LoadingSkeleton count={1} className="min-h-96 xl:h-full" />;
  }

  if (!data) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <div className="space-y-2 text-center text-base tracking-wide text-gray-600">
          <div>
            <SadFaceIcon />
          </div>

          <p>
            <FormattedMessage defaultMessage="Nenhum dado foi encontrado." id="i1Elih" />
          </p>
        </div>
      </div>
    );
  }

  const totalCompensation = [...data.totalYearlyAmericanIssuerCompensation]
    .sort((a, b) => Number(a.fiscalYear) - Number(b.fiscalYear))
    .slice(isRenderPageDefault ? -12 : undefined);

  return (
    <div className="h-full w-full space-y-4 font-aeonik font-normal">
      <AmericanTotalCompensations totalCompensations={totalCompensation} isREIT={issuer.isREIT} />

      {!viewerIsPremiumSubscriber && <UnlockPremiumContentCTA origin="American Compensations" />}
    </div>
  );
}
